// ThemeWrapper.tsx
'use client';
import React, { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createAppTheme, createThemeOverrides, ThemeProvider as ItlogixUiThemeProvider } from "@itlogix/itlogix-ui";

import CssBaseline from '@mui/material/CssBaseline';
import { useThemeOptions } from '@/app/context/themeOptionsContext';
import { defaultPaletteDark } from './darkModePalette';
import { defaultTypography } from './defaultTypography';
import { componentsTheme } from './componentsTheme';
import { defaultPalette } from './defaultPalette';

export function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const { isDarkModeEnabled, isHighContrastEnabled, isModeDislessiaEnabled, fontScale } = useThemeOptions();

  useEffect(function adjustFont() {
    const basePx = 16;
    document.documentElement.style.fontSize = `${basePx * fontScale}px`;
  }, [fontScale]);

  const theme = createAppTheme({
      ...createThemeOverrides({
        mode: isDarkModeEnabled ? 'dark' : 'light',
        isHighContrastEnabled,
        isModeDislessiaEnabled,
      }),
      typography: {
        fontFamily: 'var(--font-family)',
        ...defaultTypography,
      },
      components: componentsTheme,
      palette: (isDarkModeEnabled || isHighContrastEnabled)
        ? defaultPaletteDark
        : defaultPalette
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ItlogixUiThemeProvider theme={theme}>
          {children}
      </ItlogixUiThemeProvider>
    </ThemeProvider>
  );
}
